export const frenchPhone = (value) => {
    const str = value.replace(/\s/g, '');
    const firstTwo = str[0] + str[1];
    if (firstTwo === '06' || firstTwo === '07') {
        return true;
    }
    return 'Le champ numéro de téléphone doit commencer par 06 ou 07';
};
export const frenchPhoneSize = (value) => {
    const str = value.replace(/\s/g, '');
    if (str.length > 10) {
        return 'Le champ numéro de téléphone ne peut pas contenir plus de 10 caractères';
    }
    if (str.length < 10) {
        return 'Le champ numéro de téléphone doit contenir au minimum 10 caractères';
    }
    return true;
};
export const internationalPhone = (value) => {
    const phoneNumber = value.replace(/\s/g, '');
    const pattern = new RegExp('^(?:(?:\\+|00)33[\\s.-]{0,3}(?:0[\\s.-]{0,3})?|0)[6,7](?:(?:[\\s.-]?\\d{2}){4}|d{2}(?:[\\s.-]?d{3}){2})$');
    const result = pattern.test(phoneNumber);
    if (result === true) {
        return true;
    }
    return "Le champ numéro de téléphone n'est pas valide";
};
export const number = (value) => {
    if (value.match(/[0-9]/g) !== null) {
        return true;
    }
    return 'Le mot de passe doit contenir au moins un numéro';
};
export const zipCode = (value) => {
    const trimmedValue = value.replace(' ', '');
    if (trimmedValue.match(/^[0-9]*$/gm) !== null && trimmedValue.length == 5) {
        return true;
    }
    return 'Le code postal doit contenir 5 chiffres';
};
export const numberPers = (value) => {
    if (value.match(/^[0-9]*$/gm) !== null) {
        return true;
    }
    return 'Le numéro de personne doit être un nombre';
};
